import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { communityApi, type HomeFeedFilter } from '@/api/community';

/** Query keys (data-model.md B2). */
export const homeKeys = {
  impact: ['community', 'impact'] as const,
  spotlight: ['community', 'spotlight'] as const,
  feed: (filter: HomeFeedFilter, page = 1) => ['community', 'feed', filter, page] as const,
  profile: (memberId: string) => ['publicProfile', memberId] as const,
};

export function useCommunityImpact() {
  return useQuery({ queryKey: homeKeys.impact, queryFn: communityApi.impact });
}

export function useSpotlight() {
  return useQuery({
    queryKey: homeKeys.spotlight,
    queryFn: async () => (await communityApi.spotlight()).spotlight,
  });
}

export function useHomeFeed(filter: HomeFeedFilter, page = 1) {
  return useQuery({
    queryKey: homeKeys.feed(filter, page),
    queryFn: () => communityApi.feed(filter, page),
    // Keep the counts and the previous list visible while a new filter or page loads.
    placeholderData: keepPreviousData,
  });
}

export function usePublicProfile(memberId: string, enabled = true) {
  return useQuery({
    queryKey: homeKeys.profile(memberId),
    queryFn: () => communityApi.publicProfile(memberId),
    enabled: enabled && Boolean(memberId),
  });
}
